import { getCountry } from "../../../pages/common/utils";
import { Country } from "../booking";
import { Address } from "./address.types";

export const TimeZoneBasedCountry = getCountry() || Country.NewZealand;
export const getDefaultAddress = (country?: string): Address => ({
  street1: "",
  city: "",
  postCode: "",
  suburb: "",
  addressState: "",
  country: country ?? TimeZoneBasedCountry
});
